export enum Platform {
  ICE = 'ICE',
  SOR = 'SOR'
}
